// extracted by mini-css-extract-plugin
export default {"container":"RatingInfo_container__yiTG7","extraInfoText":"RatingInfo_extraInfoText__sT-2r","extraInfo":"RatingInfo_extraInfo__IkFLM"};